export { default as VocabularyIconsWidget } from './widgets/VocabularyIconsWidget/VocabularyIconsWidget';
export default function applyConfig(config) {
  return config;
}
